import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-anchor', 'top', 'Slinkite į puslapio viršų');
Labels.set('ui-anchor', 'bottom', 'Slinkite į puslapio apačią');
Labels.set('ui-anchor', 'left', 'Slinkite į kairę');
Labels.set('ui-anchor', 'right', 'Slinkite į dešinę');
